export interface ISuggestionPanelOption {
  id: string;
  label: string;
}

export const getSuggestionOptionId = (listboxId: string, index: number): string => `${listboxId}-option-${index}`;
